/** When the ops digest widget renders, trim redundant list prose from the assistant message. */
export function trimProseForOpsDigest(content: string, digestSummary?: string): string {
	const trimmed = content.trim()
	if (!trimmed) return digestSummary ?? ''

	const blocks = trimmed.split(/\n\n+/)
	const first = blocks[0]?.trim() ?? ''
	const isListHeavy = blocks.some((block) => /^(\s*[-*]|\s*\d+\.|\s*\|)/m.test(block))
	if (!isListHeavy) return first

	if (first.length > 0) return first
	return digestSummary ?? trimmed.split('\n')[0] ?? trimmed
}

export function failedTransactionsNavigatePath(): string {
	return '/dashboard/transactions?status=failed'
}

export function cabinetInventoryPath(storeId: number, siteId: string): string {
	return `/dashboard/stores/${storeId}/cabinets/${siteId}`
}
